export default __webpack_public_path__ + "static/media/BR - CTF2.cd3797dc.png";